import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const EmergencyMedicationsRedux = createActions(
  {
    // Custom actions
  },
  {
    prefix: 'EMERGENCY_MEDICATION_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = EmergencyMedicationsRedux
export const EmergencyMedicationsTypes = Types
export default Creators

export const INITIAL_STATE = createState({
// custom state
},
{
  get: true,
  // Default state
})

export const reducer = createReducer(
  INITIAL_STATE, {
    // custom reducers
  },
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/EmergencyMedications.js